import { ModalController, IonContent, IonGrid, IonRow, IonCol, IonButton, IonIcon, IonList } from '@ionic/angular';
import { Component, ChangeDetectionStrategy, inject, OnDestroy, input } from '@angular/core';
import { Events } from '@providers/common/events.service';

import { HtmlExcelExportService } from '@providers/excel/html-excel.service';
import { addIcons } from "ionicons";
import { close } from "ionicons/icons";
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'modal-table-detail',
    templateUrl: './modal-table-detail.component.html',
    styleUrls: ['./modal-table-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        IonContent,
        IonGrid,
        IonRow,
        IonCol,
        IonButton,
        IonIcon,
        IonList,
        MatTooltip,
        TranslatePipe,
    ],
})
export class TableDetailChatAIModal implements OnDestroy {
    private modalCtrl = inject(ModalController);
    private events = inject(Events);
    private excelExport = inject(HtmlExcelExportService);

    readonly modalTitle = input('');
    readonly modalType = input('');
    readonly tableFinanceDetail = input('');
    readonly tableOperationsDetail = input('');

    constructor() {
        this.events.publish('menulat:togglevisibility');
        addIcons({ close });
    }

    // Se vuelve a mostrar el menu al destruirse el modal, porque Ionic tambien lo
    // cierra con Escape o el boton atras de Android sin pasar por dismiss()
    ngOnDestroy() {
        this.events.publish('menulat:togglevisibility');
    }

    /**
     * @name dismiss
     * @desc Metodo que te regresa en la navegación
     **/
    dismiss() {
        this.modalCtrl.dismiss();
    }

    /* Parse and Generate excel file from Data */
    onParseDataToExcelFile(dataType: string) {

        let fileName: string;

        if (dataType === 'Financial') {

            fileName = 'FinancialData';

            this.excelExport.exportHtmlStringToExcel(this.tableFinanceDetail(), fileName);

        } else {

            fileName = 'OperationsData';
            this.excelExport.exportHtmlStringToExcel(this.tableOperationsDetail(), fileName);
        }
    }
}
